import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  legendContainer: {
    maxHeight: "50px",
    overflowY: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
  },

  legendWrapper: {
    marginRight: "10px",
    display: "flex",
    alignItems: "center",
  },

  legendIcon: {
    display: "inline-block",
    width: "10px",
    height: "10px",
    marginRight: "6px",
    borderRadius: "50%",
  },
});
